import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";

const Wrapper = ({ children }) => {
  const location = useLocation();

  const transition = {
    type: "tween",
    duration: 0.4,
    // ease: "easeInOut"
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={transition}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default Wrapper;